module.exports = __webpack_public_path__ + "img/GrayGrayDoubleCircle400.2f107d9c.png";